/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

/* eslint-disable no-underscore-dangle */
function treatment() {
    document.documentElement.classList.add('w5');

    const searchItems = ["miffy", "jellycat", "snoopy", "plane travel", "meri meri", "mushie", "bink", "change mat", "kitchen", "uppababy", "rug"];

    let searchBox, searchForm, input;

    const triggerSearch = function (e) {
        const itemNode = e.target.closest('.item');
        input.value = itemNode.innerHTML;
        searchForm.submit();
    };

    const createSearchItems = function () {
        if (!searchItems || !searchItems.length || !searchBox) {
            return;
        }

        const dropdown = searchBox.querySelector('.dropdown');
        let searchItemNode;

        for (let i = 0; i < searchItems.length; i++) {
            searchItemNode = document.createElement('div');
            searchItemNode.className = 'item';
            searchItemNode.innerHTML = searchItems[i];
            dropdown.insertAdjacentElement('beforeend', searchItemNode);

            searchItemNode.addEventListener('click', triggerSearch);
        }
    };

    const addSearchBox = function (boxContainer) {
        const inputPlaceholder = 'Search 5,200+ baby products';
        searchBox = document.createElement('div');
        searchBox.className = 'masthead-search';

        searchBox.innerHTML =
            `<form method="get" action="/search">
                <div class="inner">
                    <input type="search" name="q" placeholder="${inputPlaceholder}" aria-label="${inputPlaceholder}" autocomplete="off" spellcheck="false" role="combobox" aria-autocomplete="both" aria-expanded="false">
                    <button type="submit" class="btn-submit">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path></svg>
                    </button>
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>
                 </div>
                 <div class="dropdown">
                    <div class="title">Popular this week</div>
                 </div>
             </form>`;

        boxContainer.insertAdjacentElement('beforeend', searchBox);
        createSearchItems();

        const searchIcon = searchBox.querySelector('.btn-submit');
        const clearIcon = searchBox.querySelector('.icon-close');
        searchForm = searchBox.querySelector('form');
        input = searchBox.querySelector('input');

        input.addEventListener('focus', function () {
            if (input.value) {
                searchBox.classList.remove('show-dropdown');
            } else {
                searchBox.classList.add('show-dropdown');
            }
        });

        document.addEventListener('click', function (e) {
            if (e.target !== input) {
                searchBox.classList.remove('show-dropdown');
            }
        });

        input.addEventListener('input', function () {
            searchBox.classList.remove('show-dropdown');
            if (input.value) {
                searchIcon.style.display = 'none';
                clearIcon.style.display = 'inline-block';
            } else {
                clearIcon.style.display = 'none';
                searchIcon.style.display = 'inline-block';
            }
        });

        clearIcon.addEventListener('click', function () {
            input.value = '';
            clearIcon.style.display = 'none';
            searchIcon.style.display = 'inline-block';
        });

        Mojito.utils.watchElement(input, function () {
            input.placeholder = inputPlaceholder;
        }, { attributes: true });
    };

    Mojito.utils.waitForElement('.shopify-section.index-section--hero', addSearchBox);


}

if (location.pathname === '/') {
    treatment();
}
